






































import ModalBase from "@/components/modal/ModalBase.vue";
import {Component, Mixins, Prop, Vue} from "vue-property-decorator";
import {IOrderHistory} from "@/entities";
import HistorySection from "@/components/HistorySection.vue";
import {StatusTagType} from "@/components/lib/models";
import onLocaleChangeMixin from "@/mixins/onLocaleChangeMixin";
@Component({
  components: {
    ModalBase,
    HistorySection
  }
})
export default class OrderHistoryList extends Mixins(onLocaleChangeMixin) {
  @Prop() readonly mapMethod?: (status?: string) => StatusTagType;
  @Prop() readonly token!: string;
  @Prop() readonly id!: number;
  @Prop() readonly onClose?: Function

  protected histories: IOrderHistory[] = [];
  protected fetching: boolean = false;

  protected initFetches = [
    this.fetchHistories
  ];

  private fetchHistories(): void {
    if (!this.histories?.length) {
      this.fetching = true;
      this.$storage.actions.getOrderHistories({
        key: this.token
      })
        .then(res => {
          this.histories = res;
        })
        .catch(() => {})
        .finally(() => {
          this.fetching = false;
        });
    }
  }
}
